declare const $: (selector: string) => { addClass(className: string): void };

export class BrowserUtils {
  static isUnload = false;
  private static xsrfByHost = new Map<string, ICsrfToken>();

  static getAllXsrf(): { [key: string]: ICsrfToken} {
    const result: { [key: string]: ICsrfToken} = {};
    BrowserUtils.xsrfByHost.forEach((value, key) => result[key] = value)
    return result;
  }

  static hasCookie(name: string) {
    return BrowserUtils.getCookie(name) !== undefined;
  }

  static getCookie(name: string) {
    const matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  static getBrowserName() {
    const ua = navigator.userAgent;
    let tem;
    let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
      M.splice(1, 1, tem[1]);
    }

    return M.map(d => d.toLowerCase()).join(' ');
  }

  static isSafari() {
    return (
      /constructor/i.test(String(window.HTMLElement)) ||
      (function (p) {
        return p.toString() === '[object SafariRemoteNotification]';
      })(!window['safari'] || (typeof window['safari'] !== 'undefined' && window['safari'].pushNotification))
    );
  }

  static escapeHtml(unsafe: string) {
    if (!unsafe) {
      return '';
    }
    return unsafe
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;')
      .replace(/\//g, '&#x2F;');
  }

  static sanitizeHTML(text: string) {
    const element = document.createElement('div');
    element.innerText = text;
    return element.innerHTML;
  }

  static initPlugins() {
    $('body').addClass(BrowserUtils.getBrowserName());
  }

  static getXsrfKey(url: string): string | null {
    try {
      return new URL(url).host;
    } catch (error) {
      console.error('Failed to resolve XSRF token key from URL', url, error);
      return null;
    }
  }

  static getXsrfValue(url: string): string | null {
    const key = BrowserUtils.getXsrfKey(url);
    if (!key) {
      return null;
    }
    const token = BrowserUtils.xsrfByHost.get(key);
    if (!token) {
      return null;
    }
    return token.value;
  }

  static setXsrfValue(tokenValue: string | null, url: string | null) {
    if (!tokenValue || !url) {
      return;
    }

    const key = BrowserUtils.getXsrfKey(url);
    if (key) {
      let token = this.xsrfByHost.get(key);
      if (!token) {
        token = {
          value: tokenValue,
          createdAt: new Date(),
          updatedAt: null,
        };
      } else {
        token.value = tokenValue;
        token.updatedAt = new Date();
      }
      BrowserUtils.xsrfByHost.set(key, token);
    }
  }

  static clearXsrf() {
    BrowserUtils.xsrfByHost.clear();
  }

  static downloadFile(blob: Blob, fileName: string) {
    const elem = window.document.createElement('a');
    elem.href = window.URL.createObjectURL(blob);
    elem.download = fileName;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
  }

  static copyToClipboard(text: string) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then();
    } else {
      const textArea = document.createElement('textarea');
      textArea.style.position = 'fixed';
      textArea.style.top = String(0);
      textArea.style.left = String(0);
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
      } catch {
        // Ignore clipboard errors; this fallback is best-effort.
      }
      document.body.removeChild(textArea);
    }
  }

  static isProd(): boolean {
    return location.hostname === 'app.telqtele.com';
  }

  static getHostUrl() {
    return this.isProd() ? 'https://app.telqtele.com' : 'https://app.dev.telqtele.com';
  }

  static getPageWrapperHeight(): number {
    const wrapper = document.getElementsByClassName('content-wrapper').item(0) as HTMLElement;

    return wrapper.clientHeight;
  }

  static getCurrentVersion(): string {
    return window['CURRENT_VERSION'];
  }
}

interface ICsrfToken {
  value: string;
  createdAt: Date;
  updatedAt: Date|null;
}
